import React, { Component } from 'react';

import { AuctionFinalsTotals } from 'components/AuctionFinals/components';

class AwardAllInfo extends Component {
  render() {
    const { store } = this.props;
    const { sale } = store.auctionFinalsStore;

    return (
      <AuctionFinalsTotals
        store={store.auctionFinalsStore}
        locale={sale.saleEdit.locale}
        currency={sale.saleEdit.currencyCode}
      />
    );
  }
}

export default AwardAllInfo;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/AwardAll/Info.jsx